<div *ngIf="(stepState && stepState !== 'active') || show">
    <div class="circle-loader center gray thin topspacer bottomspacer"></div>
</div>
